import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const minDesktopCardHeight = 170;

const useBaseWrapperStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageContainer: {
      maxWidth: 750,
    },
    buttonContainer: {
      width: '100%',
      display: 'inline-block',
      marginTop: theme.spacing(1),
      marginBottom: 20,
      [theme.breakpoints.up('md')]: {
        width: 300,
      },
    },
    minHeightDesktopCard: {
      [theme.breakpoints.up('md')]: {
        minHeight: minDesktopCardHeight,
      },
    },
  }),
);

export default useBaseWrapperStyles;
